// status 0:没有创建支付宝交易1:等待买家付款 2:等待卖家发货,即:买家已付款 3:付款以后用户退款成功，交易自动关闭 4:卖家部分发货 5:交易成功 6:等待买家确认收货,即:卖家已发货 7:付款以前，卖家或买家主动关闭交易 8:国际信用卡支付付款确认中
import utils from '@/libs/utils';
import Http from '@/libs/http';
import moment from 'moment';
import router from '../../router';
import Message from 'element-ui/lib/message';

export default {
  // 校验所有飞猪的状态
  async checkFliggyStatus(
    otaInfo,
    // 是否需要校验
    needCheckMap = {},
  ) {
    try {
      if (!otaInfo) return { isSuccess: true };
      const finnalNeedCheck = Object.assign({}, {
        is_auth: false, // 飞猪授权过期
        status: false, // 飞猪店铺停用了
        ota_status: false, // oss后台飞猪店铺停用了
        ota_order_status: false, // 飞猪订单已退款
        ota_applicant_status: false, // 飞猪申请人暂停办理
      }, needCheckMap);
      return new Promise((resolve, reject) => {
        Http.post('/ota_order_status_update', { ota_sub_order_id: otaInfo.ota_sub_order_id })
          .then((res) => {
            Promise.resolve()
              .then(() => {
                if (!finnalNeedCheck.is_auth) return;
                // 飞猪授权过期
                if (!res.is_auth || moment(res.auth_expires).isBefore(moment(), 'minutes')) {
                  return utils.msgbox.confirm('当前飞猪店铺授权已过期，请使用飞猪店铺管理员账号重新绑定授权', '飞猪店铺提示', {
                    confirmButtonText: '去授权',
                    cancelButtonText: '忽略该提示',
                    type: 'warning',
                  }).then(() => {
                    const { href } = router.resolve({ path: '/user/shop' });
                    window.open(href, '_blank');
                    return Promise.reject();
                  }).catch(() => Promise.reject());
                }
              })
              .then(() => {
                if (!finnalNeedCheck.status) return;
                // 飞猪店铺停用了
                if (!res.status) {
                  return utils.msgbox.confirm('当前飞猪店铺已禁用，请重新启用飞猪店铺', '飞猪店铺提示', {
                    confirmButtonText: '立即启用',
                    cancelButtonText: '取消',
                    type: 'warning',
                  }).then(() => Http.post('/peer_ota_status_switch', { status: 1, id: otaInfo.peer_ota_id })).then(() => {
                    // 启动成功
                    Message.success('启用成功');
                  }).catch(() => Promise.reject());
                }
              })
              .then(() => {
                if (!finnalNeedCheck.ota_status) return;
                // 后台飞猪店铺停用了
                if (!res.ota_status) {
                  return utils.msgbox.confirm('您尚未开通飞猪订单同步服务，请联系商务经理', '飞猪店铺提示', {
                    confirmButtonText: '知道了',
                    showCancelButton: false,
                    type: 'warning',
                  })
                    .then(() => Promise.reject())
                    .catch(() => Promise.reject());
                }
              })
              .then(() => {
                if (!finnalNeedCheck.ota_order_status) return;
                // 飞猪订单已退款
                if (res.ota_order_status === 3) {
                  // 已退款
                  return utils.msgbox.confirm('该飞猪订单已退款，仍然要继续支付并办理签证吗？', '飞猪店铺提示', {
                    confirmButtonText: '继续',
                    type: 'warning',
                  }).catch(() => Promise.reject());
                }
              })
              .then(() => {
                if (!finnalNeedCheck.ota_applicant_status) return;
                // 飞猪申请人暂停办理
                if (res.ota_applicant_status && res.ota_applicant_status.some(item => item === 1)) {
                  // 已退款
                  return utils.msgbox.confirm('该飞猪订单申请人当前状态为暂停办理，仍然要继续支付并办理签证吗？', '飞猪店铺提示', {
                    confirmButtonText: '继续',
                    type: 'warning',
                  }).catch(() => Promise.reject());
                }
              })
              .then(() => {
                resolve({ isSuccess: true, data: res });
              })
              .catch(() => {
                resolve({ isSuccess: false, data: res });
              });
          })
          .catch(() => {
            reject();
          });
      });
    } catch (error) {
      return Promise.reject();
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/modules/fliggy-service.js